<template>
  <div id="app" class="container-fluid">
    <TheHeader/>
    <router-view :key="$route.fullPath"></router-view>
    <TheFooter/>
  </div>
</template>

<script>
 require('@/styles/style.css')

 import TheHeader from '@/components/TheHeader'
 import TheFooter from '@/components/TheFooter'

 export default {
   name: 'DevPortal',
   components: {
     TheHeader,
     TheFooter
   },
   metaInfo: {
     title: 'Page',
     titleTemplate: '%s | ObserveIT Developers'
   }
 }
</script>

<style>
 @import url('https://fonts.googleapis.com/css?family=Open+Sans');
 @import url('https://fonts.googleapis.com/css?family=Titillium+Web');


 #app {
     font-family: 'Open Sans', sans-serif;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
     color: #002330;
     background-color: white;
     margin: 0;
 }

 h1, h2, h3 {
     font-family: 'Titillium Web', sans-serif;
     padding-bottom: 1px;
 }

 h1 {
     font-size: 52px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
 }

 h2 {
     text-align: left;
     font-weight: 600;
     font-size: 24px;
     color: #e4522a;
 }
 
 body {
     line-height: normal;
     font-size: 18px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: 1.5;
     letter-spacing: normal;
     color: #002330;
 }
 
 .container-flex {
     display: flex;
     flex-flow: column;
     position: relative;
 }
 
 li.chevrons {
	   padding-left: 18px;
     margin-bottom: 20px;
	   list-style: none;
     background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11"><path d="M4.648 5.498L.19 9.613a.574.574 0 0 0 0 .85l.39.361a.675.675 0 0 0 .462.176.675.675 0 0 0 .46-.176l5.308-4.9a.574.574 0 0 0 0-.853L1.508.176A.675.675 0 0 0 1.047 0a.675.675 0 0 0-.461.176l-.39.36a.57.57 0 0 0 0 .851l4.452 4.11z" stroke="none" fill="%23f1582b"/></svg>');
	   background-repeat: no-repeat;
	   background-position: left 9px;;
	   background-size: 12px;
 }

 li {
     list-style-type: none;
     text-align: left;
 }

 p {
     font-size: 16px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
 }
</style>
